/**
 * Posiciones (x, y) en % de cada sistema en el plano del mapa galáctico.
 * Fuente: Archilele's Two Word Guide to the 'Verse (coordenadas 1000×600 normalizadas a 0–100).
 */
import { getPositionsFromArchilele } from './archilele_map';

export const POSICIONES_MAPA = getPositionsFromArchilele();
